import React from 'react';
import PropTypes from 'prop-types';
import { Button } from '@els/els-react--button';
import Catalyst from '@Services/Catalyst';

function Footer({ selfClose, submitAlertFormEnabled, submitAlertForm, isEditMode, isMigrateMode }) {
  let buttonText;
  if (isEditMode) {
    buttonText = 'Save';
  } else if (isMigrateMode) {
    buttonText = 'Migrate';
  } else {
    buttonText = 'Create';
  }

  const handleSubmitClick = () => {
    Catalyst.trackEvent('buttonClick', {
      buttonType: 'rx2:history:type=button:name=popup-create-alert',
    });
    submitAlertForm();
  };

  return (
    <div className="els-btn-group-right">
      <Button
        type="tertiary"
        onClick={selfClose}
        data-e2e="create-alert-cancel"
        aria-label="Cancel Alert Creation"
        className="e2e-create-alert-cancel">
        Cancel
      </Button>

      <Button
        type="primary"
        onClick={handleSubmitClick}
        disabled={!submitAlertFormEnabled}
        aria-label={`${buttonText} Alert`}
        data-e2e="create-alert-submit-button"
        className="e2e-create-alert-create">
        {buttonText}
      </Button>
    </div>
  );
}

Footer.propTypes = {
  selfClose: PropTypes.func.isRequired,
  submitAlertFormEnabled: PropTypes.bool,
  submitAlertForm: PropTypes.func.isRequired,
  isEditMode: PropTypes.bool,
  isMigrateMode: PropTypes.bool,
};

export default React.memo(Footer);
